<template>
  <div class="qf-table-cell" :style="{ width: colWidth + 'px', textAlign: colAlign }">
    <template v-if="row.hasData">
      <component v-if="colRender" :key="row?.[col.colKey]" :is="colRender(row)" />
      <slot v-else :name="col.colKey" :row="row" :index="colIndex"> {{ row?.[col.colKey] ?? '-' }} </slot>
      <slot></slot>
    </template>
    <div v-else class="qf-table-cell-container">
      <div class="qf-table-cell-placeholder"></div>
    </div>
  </div>
</template>

<script setup>
import { onUnmounted, shallowRef, watch, computed } from 'vue';

const props = defineProps({
  column: {
    type: Object,
    default: () => {}
  },
  row: {
    type: Object,
    default: () => {}
  },
  colIndex: {
    type: Number,
    default: 0
  }
});

// 使用 shallowRef 避免内部属性变化触发更新
const col = shallowRef(props.column);

// 监听 props.column 的变化，更新 col 的引用
const stopWatch = watch(
  () => props.column,
  (newColumn) => {
    col.value = newColumn;
  }
);

// 使用 computed 缓存列的宽度
const colWidth = computed(() => col.value.width);
// 使用 computed 缓存列的对齐方式
const colAlign = computed(() => col.value.align);
// 使用 computed 缓存列的渲染函数
const colRender = computed(() => col.value.render);

// 在组件卸载时停止监听
onUnmounted(() => {
  stopWatch();
});
</script>

<style scoped lang="less">
@import './qf-table-cell-group.less';
</style>
